import React, { useState, useEffect } from 'react';

const Timer = ({ chatGPTOutput }) => {
    const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
    const [currentTaskIndex, setCurrentTaskIndex] = useState(0);
    const [countdown, setCountdown] = useState(null);
    const [sessionEndTime, setSessionEndTime] = useState(null);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date().toLocaleTimeString());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!chatGPTOutput || !chatGPTOutput.data) return;
        setSessionEndTime(new Date(chatGPTOutput.data[chatGPTOutput.data.length - 1].datetime));

        const checkCurrentTask = () => {
            const now = new Date();
            
            for (let i = 0; i < chatGPTOutput.data.length; i++) {
                if (new Date(chatGPTOutput.data[i].datetime) > now) {
                    setCurrentTaskIndex(i === 0 ? 0 : i - 1);
                    document.title = chatGPTOutput.data[i === 0 ? 0 : i - 1].task;
                    const timeToNextTask = new Date(chatGPTOutput.data[i].datetime) - now;
                    setCountdown(Math.ceil(timeToNextTask / 1000));
                    break;
                } else if (i === chatGPTOutput.data.length - 1) {
                    setCurrentTaskIndex(i);
                    setCountdown(null);
                    document.title = chatGPTOutput.data[i].task;
                }
            }
        };
        
        const interval = setInterval(checkCurrentTask, 1000);
        return () => clearInterval(interval);
    }, [chatGPTOutput]);

    const formatDuration = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds - (hours * 3600)) / 60);
        const remainingSeconds = seconds - (hours * 3600) - (minutes * 60);
        
        let formattedDuration = "";
        
        if (hours > 0) formattedDuration += `${hours} Hours `;
        if (minutes > 0) formattedDuration += `${minutes} Minutes `;
        if (remainingSeconds > 0 || (hours === 0 && minutes === 0)) formattedDuration += `${remainingSeconds} Seconds`;
        
        return formattedDuration.trim();
    };

    const getSessionProgress = () => {
        if (!sessionEndTime) return 0;
        const now = new Date();
        const sessionStartTime = new Date(chatGPTOutput.data[0].datetime);
        const totalSessionTime = sessionEndTime - sessionStartTime;
        const elapsedSessionTime = now - sessionStartTime;
        return Math.min(100, (elapsedSessionTime / totalSessionTime) * 100);
    };

    return (
        <div className="timer">
            <div className="current-time">{currentTime}</div>
            <div className="chatGPT-output">
                <div className="session-progress-bar" style={{ width: `${getSessionProgress()}%` }}></div>
                {/* <div className="session-time-remaining">Session Ends At: {sessionEndTime ? sessionEndTime.toLocaleTimeString() : ''}</div> */}
                <div className="tasks-list">
                    {chatGPTOutput && chatGPTOutput.data ? (
                        <>
                            <div className="task current-task">
                                <h4>Current Task:</h4>
                                <h3>{chatGPTOutput.data[currentTaskIndex].task}</h3>
                                <p>{chatGPTOutput.data[currentTaskIndex].short_description}</p>
                            </div>
                            {countdown && chatGPTOutput.data[currentTaskIndex + 1] && (
                                <div className="task next-task">
                                    <h4>Next Task:</h4>
                                    <h3>{chatGPTOutput.data[currentTaskIndex + 1].task} - starts in {formatDuration(countdown)}</h3>
                                    <p>{chatGPTOutput.data[currentTaskIndex + 1].short_description}</p>
                                </div>
                            )}
                        </>
                    ) : (
                        <p>Loading tasks...</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Timer;